import {
    SPARQL_ENDPOINT
} from '../../common/constants';
import {queries} from '../../common/queries/index'; 
import query from '../../common/sparql/index';
import * as _ from 'lodash';

/**
 * Aggregate the data based on the current state of the filters
 * in order to be visualized in the treemap
 */
function consolidateData(iscritti, diplomati) {
    iscritti.forEach( o => {
        o.studentType = 'iscritti';
        o.year = parseInt(
            o.year.substring(0, o.year.indexOf('/'))
        );
    });
    diplomati.forEach( o => {
        o.studentType = 'diplomati';
        o.year = parseInt(o.year);
    });

    let all = _.concat([], iscritti, diplomati);

    // sanitize empty values
    return _.forEach(all, o => {
        _.isEmpty(o.foreignMale) && _.isNil(o.foreignMale) && (o.foreignMale = 0)
        _.isEmpty(o.foreignFemale) && _.isNil(o.foreignFemale) && (o.foreignFemale = 0)
    });            
} 



export async function getUSTATDataPHD() {
    const iscritti  = await query(SPARQL_ENDPOINT, queries.postgraduatesIscrittiPHD);
    const diplomati = await query(SPARQL_ENDPOINT, queries.postgraduatesDiplomatiPHD);
    return consolidateData(iscritti, diplomati);
}